import CloseIcon from '@diligentcorp/atlas-react-icons/dist/esm/lens/Close.js';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

interface DiscardChangesModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const TITLE_ID = 'discard-changes-modal-title';

export const DiscardChangesModal: React.FC<DiscardChangesModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby={TITLE_ID}
    data-testid="discard-changes-modal"
  >
    <DialogTitle component="div">
      <Typography variant="h6" component="h2" id={TITLE_ID}>
        Discard changes
      </Typography>
      <IconButton
        onClick={onClose}
        aria-label="Close"
        size="small"
        color="inherit"
        data-testid="discard-changes-modal-close"
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography>
        You have unsaved changes.
        <br />
        If you continue, all changes will be lost.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'space-between' }}>
      <Button
        variant="outlined"
        onClick={onClose}
        data-testid="discard-changes-cancel-button"
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="destructive"
        onClick={onConfirm}
        autoFocus
        data-testid="discard-changes-continue-button"
      >
        Continue
      </Button>
    </DialogActions>
  </Dialog>
);
